module.exports = __webpack_public_path__ + "static/pdf-sample-fa7d7e650b2cec68f302b31ba28235d8.pdf";